import type { WebapiEndpointBuilder } from '@/api/webapi.ts';

export type GetClosedDatesBody = string[]; // list of currency pairs like ["EUR/USD", "GBP/JPY"]
export type GetClosedDatesResponse = Record<string, string[]>; // record of currency pairs as keys and arrays of closed dates as values like { "EUR/USD": ["2023-10-05", "2023-10-06"], "GBP/JPY": ["2023-10-07"] }

export const getClosedDates = (builder: WebapiEndpointBuilder) => {
  return builder.query<GetClosedDatesResponse, GetClosedDatesBody>({
    query: (body) => ({
      url: '/dates/closed',
      method: 'POST',
      body,
    }),
  });
};
